import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar.js";
// เพิ่ม loading ใน import
import { tokens, success, GET, PUT, total, getStorage, toFixed, format_date, DatePicker, loading, calculate_water } from "../../components/CustomComponent.js";
import Swal from "sweetalert2";
import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";

const role = getStorage("role_detail");
const view_r = role?.find((item) => item.name === "employee")?.role[0] === 1;

// ย้าย fields ออกมาข้างนอกเพื่อไม่ให้สร้างใหม่ทุกครั้งที่รันฟังก์ชัน GetAll
const calculationFields = [
  { k: "water_bill", sk: "s_water_bill" }, { k: "waste_cost", sk: "s_waste_cost" },
  { k: "reduce_debt", sk: "s_reduce_debt", m: -1 }, { k: "other_income", sk: "s_other_income" },
  { k: "meter_connect_cost", sk: "s_meter_connect_cost" }, { k: "total_cost_late", sk: "s_late_payment" },
  { k: "equipment_maintenance_fee", sk: "s_equipment_maintenance_fee" }, { k: "common_expenses", sk: "s_common_expenses" },
  { k: "cable_cost", sk: "s_cable_cost" }, { k: "add_debt", sk: "s_add_debt" }, { k: "fire_cost", sk: "s_fire_cost" }
];

// คอลัมน์สำหรับ tab "เลือกตัดเฉพาะรายการ" — ใช้ชื่อคอลัมน์และลำดับเดียวกับ tab "ตัดทั้งยอด" ทุกอย่าง
// ข้อมูลจาก Record_water_writeoff_item (as_json_page คืนค่ามาตรงคอลัมน์อยู่แล้ว ไม่ต้องคำนวณเพิ่ม)
const writeoffItemColumns = [
  { key: "water_bill", label: "ค่าน้ำประปา" },
  { key: "equipment_maintenance_fee", label: "ค่ารักษาอุปกรณ์น้ำ" },
  { key: "common_expenses", label: "ค่าส่วนกลาง" },
  { key: "waste_cost", label: "ค่าขยะ" },
  { key: "cable_cost", label: "ค่าเคเบิล" },
  { key: "other_income", label: "รายรับอื่นๆ" },
  { key: "debt_adjust", label: "เพิ่ม/ลดหนี้", compute: (item) => (item.add_debt || 0) - (item.reduce_debt || 0) },
  { key: "fire_cost", label: "ค่าเบี้ยประกัน" },
  { key: "meter_connect_cost", label: "ค่าต่อกลับมิเตอร์" },
  { key: "total_cost_late", label: "ค่าปรับชำระล่าช้า" },
];

export default class Employee extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    modal_update: false, page: 1, filter_data_search: "",
    start_date: null, end_date: null, data: null, id: "",
    list_mode: "old", // "old" = ตัดทั้งยอด (เดิม), "new" = เลือกตัดเฉพาะรายการ
    data_item: null, modal_update_item: false, id_item: "",
  });

  async componentDidMount() {
    loading(false); // เรียกใช้ตั้งแต่เข้ามาหน้าครั้งแรก
    await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const { filter_data_search, start_date, end_date, page } = this.state;
    
    let payload = {
      data_search: filter_data_search,
      start_date: start_date ? format_date(start_date, "yyyy-mm-dd", "en") : "",
      end_date: end_date ? format_date(end_date, "yyyy-mm-dd", "en") : "",
    };

    let result = await GET(tokens, `v1/TH/record-water/water-clear-bill/page/${page}/${getStorage("project_id")}`, payload);
    
    if (result?.status) {
      let resData = result.data;

      for (let item of resData.data) {
        if(item.transaction_payments?.length > 0) {
          // s_add_debt
          // s_cable_cost
          // s_common_expenses
          // s_equipment_maintenance_fee
          // s_fire_cost
          // s_late_payment
          // s_meter_connect_cost
          // s_other_income
          // s_reduce_debt
          // s_waste_cost
          // s_water_bill
          if(item.transaction_payments.every(p => !p.s_water_bill)) {
            item.water_bill = total(item.transaction_payments.filter(p => !p.s_water_bill),"water_bill");
          }else{
            item.water_bill = 0;
          }
          if(item.transaction_payments.every(p => !p.s_waste_cost)) {
            item.waste_cost = total(item.transaction_payments.filter(p => !p.s_waste_cost),"waste_cost");
          }else{
            item.waste_cost = 0;
          }
          if(item.transaction_payments.every(p => !p.s_reduce_debt)) {
            item.reduce_debt = total(item.transaction_payments.filter(p => !p.s_reduce_debt),"reduce_debt");
          }else{
            item.reduce_debt = 0;
          }
          if(item.transaction_payments.every(p => !p.s_other_income)) {
            item.other_income = total(item.transaction_payments.filter(p => !p.s_other_income),"other_income");
          }else{
            item.other_income = 0;
          }
          if(item.transaction_payments.every(p => !p.s_meter_connect_cost)) {
            item.meter_connect_cost = total(item.transaction_payments.filter(p => !p.s_meter_connect_cost),"meter_connect_cost");
          } else{
            item.meter_connect_cost = 0;
          }
          if(item.transaction_payments.every(p => !p.s_late_payment)) {
            item.total_cost_late = total(item.transaction_payments.filter(p => !p.s_late_payment),"total_cost_late");
          } else {
            item.total_cost_late = 0;
          }
          if(item.transaction_payments.every(p => !p.s_fire_cost)) {
            item.fire_cost = total(item.transaction_payments.filter(p => !p.s_fire_cost),"fire_cost");
          } else {
            item.fire_cost = 0;
          }
          if(item.transaction_payments.every(p => !p.s_equipment_maintenance_fee)) {
            item.equipment_maintenance_fee = total(item.transaction_payments.filter(p => !p.s_equipment_maintenance_fee),"equipment_maintenance_fee");
          } else {
            item.equipment_maintenance_fee = 0;
          }
          if(item.transaction_payments.every(p => !p.s_common_expenses)) {
            item.common_expenses = total(item.transaction_payments.filter(p => !p.s_common_expenses),"common_expenses");
          } else {
            item.common_expenses = 0;
          }
          if(item.transaction_payments.every(p => !p.s_cable_cost)) {
            item.cable_cost = total(item.transaction_payments.filter(p => !p.s_cable_cost),"cable_cost");
          } else {
            item.cable_cost = 0;
          }
          if(item.transaction_payments.every(p => !p.s_add_debt)) {
            item.add_debt = total(item.transaction_payments.filter(p => !p.s_add_debt),"add_debt");
          } else {
            item.add_debt = 0;
          }
          item.total_amount = item.water_bill + item.waste_cost + item.other_income + item.meter_connect_cost + item.total_cost_late + item.fire_cost + item.equipment_maintenance_fee + item.common_expenses + item.cable_cost + item.add_debt - item.reduce_debt;
        }
      }

      this.setState({ data: resData });
    }
    loading(false);
  };

  // ===== tab "เลือกตัดเฉพาะรายการ" — คนละ endpoint กับ GetAll ด้านบน ไม่ยุ่งกับ tab เดิม =====
  GetAllItem = async () => {
    loading(true);
    const { filter_data_search, start_date, end_date, page } = this.state;

    let payload = {
      data_search: filter_data_search,
      start_date: start_date ? format_date(start_date, "yyyy-mm-dd", "en") : "",
      end_date: end_date ? format_date(end_date, "yyyy-mm-dd", "en") : "",
    };

    let result = await GET(tokens, `v1/TH/record-water/water-clear-bill-item/page/${page}/${getStorage("project_id")}`, payload);

    if (result?.status) {
      this.setState({ data_item: result.data });
    }
    loading(false);
  };

  switchListMode = (mode) => {
    if (mode === this.state.list_mode) return;
    this.setState({ list_mode: mode, page: 1 }, mode === "new" ? this.GetAllItem : this.GetAll);
  };

  Search = () => this.setState({ page: 1 }, this.state.list_mode === "new" ? this.GetAllItem : this.GetAll);

  Reset = () => this.setState(
    { filter_data_search: "", start_date: null, end_date: null, page: 1 },
    this.state.list_mode === "new" ? this.GetAllItem : this.GetAll
  );

  cancelClearBill = async (ids) => {
    const {data} = this.state;
    loading(true);
    let promises = ids.map(id => PUT(tokens, `v1/TH/record-water/cancle-clear-bill/${getStorage("project_id")}`, { record_water_id: id }));
    let results = await Promise.all(promises);
    
    if (results.every(res => res?.status)) {
      // ดึงและกรองข้อมูลให้เหลือเฉพาะ address_number ที่ไม่ซ้ำกัน
      const address_list = data.data
        .filter(e => ids.includes(e.record_water_id))
        .map(e => e.address_number);

      const unique_addresses = [...new Set(address_list)];

      // ใช้ for...of เพื่อให้ระบบรอ (await) ให้เสร็จทีละรายการ
      for (const address of unique_addresses) {
        await calculate_water(address);
      }
      success();
      this.clear_form();
      this.GetAll();
    } else {
      loading(false);
    }
  };

  // ยกเลิกตัดหนี้แบบเลือกตัดเฉพาะรายการ — คนละ endpoint กับ cancelClearBill ด้านบน ไม่ยุ่งกับ tab เดิม
  cancelClearBillItem = async (writeoff_item_ids) => {
    const { data_item } = this.state;
    loading(true);
    let result = await PUT(tokens, `v1/TH/record-water/cancle-clear-bill-item/${getStorage("project_id")}`, { writeoff_item_list: writeoff_item_ids });

    if (result?.status) {
      const address_list = data_item.data
        .filter(e => writeoff_item_ids.includes(e.writeoff_item_id))
        .map(e => e.address_number);

      const unique_addresses = [...new Set(address_list)];

      for (const address of unique_addresses) {
        await calculate_water(address);
      }
      success();
      this.setState({ filter_data_search: "", start_date: null, end_date: null, page: 1, modal_update_item: false, id_item: "" }, this.GetAllItem);
    } else {
      loading(false);
    }
  };

  toggleAll = (e) => {
    let data = { ...this.state.data };
    data.data.forEach(item => item.selected = e.target.checked);
    this.setState({ data });
  };

  toggleItem = (index, checked) => {
    let data = { ...this.state.data };
    data.data[index].selected = checked;
    this.setState({ data });
  };

  // checkbox ของ tab "เลือกตัดเฉพาะรายการ" — ใช้กับ cancelClearBillItem ด้านบน
  toggleAllItem = (e) => {
    let data_item = { ...this.state.data_item };
    data_item.data.forEach(item => item.selected = e.target.checked);
    this.setState({ data_item });
  };

  toggleItemItem = (index, checked) => {
    let data_item = { ...this.state.data_item };
    data_item.data[index].selected = checked;
    this.setState({ data_item });
  };

  clear_form = () => this.setState(this.getInitialState(), this.GetAll);

  render() {
    const { data, data_item, filter_data_search, start_date, end_date, page, modal_update, modal_update_item, list_mode } = this.state;
    const fmt = (val) => val ? toFixed(val) : "0.00";
    const num = (val) => val ? Number(val) : "0";
    const hasSelected = data?.data?.some(e => e.selected);
    const hasSelectedItem = data_item?.data?.some(e => e.selected);
    const activeData = list_mode === "new" ? data_item : data;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายการตัดหนี้" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3"><b>รายการตัดหนี้</b></h4>
              </div>

              {/* สลับโหมดการตัดยอด */}
               <div className="d-flex align-items-center mb-3">
                <div className="btn-group">
                  <button
                    type="button"
                    className={`mr-2 btn btn-sm ${list_mode === "old" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => this.switchListMode("old")}
                  >ตัดทั้งยอด (เดิม)</button>
                  <button
                    type="button"
                    className={`btn btn-sm ${list_mode === "new" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => this.switchListMode("new")}
                  >เลือกตัดเฉพาะรายการ (ใหม่)</button>
                </div>
              </div> 

              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <div className="d-flex align-items-center row mx-0">
                  <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ filter_data_search: e.target.value })} value={filter_data_search} />
                  <div className="wpx-200 mb-3"><DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ start_date: e })} value={start_date} /></div>
                  <span className="mb-3">ถึง</span>
                  <div className="wpx-200 mb-3"><DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." onChange={(e) => this.setState({ end_date: e })} value={end_date} /></div>
                  <button className="btn btn-primary px-3 mb-3 mx-1" onClick={this.Search}>ค้นหา</button>
                  <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={this.Reset}>รีเซ็ท</button>
                </div>

                {list_mode === "old" && hasSelected && (
                  <button className="btn btn-danger px-3 mb-3 mx-1" onClick={() => {
                    Swal.fire({
                      icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
                      showCancelButton: true, cancelButtonColor: "#d33", confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก",
                    }).then((result) => result.isConfirmed && this.cancelClearBill(data.data.filter(e => e.selected).map(e => e.record_water_id)));
                  }}>
                    ลบรายการที่เลือก
                  </button>
                )}

                {list_mode === "new" && hasSelectedItem && (
                  <button className="btn btn-danger px-3 mb-3 mx-1" onClick={() => {
                    Swal.fire({
                      icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
                      showCancelButton: true, cancelButtonColor: "#d33", confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก",
                    }).then((result) => result.isConfirmed && this.cancelClearBillItem(data_item.data.filter(e => e.selected).map(e => e.writeoff_item_id)));
                  }}>
                    ลบรายการที่เลือก
                  </button>
                )}
              </div>

              <div className="table-responsive">
                {list_mode === "old" ? (
                <table className="table table-borderless table-striped text-nowrap">
                  <thead className="bg-dark-blue text-white">
                    <tr className="bg-primary">
                      <th><input type="checkbox" className="pointer" onChange={this.toggleAll} checked={data?.data?.length > 0 && data.data.every((item) => item.selected)} /></th>
                      <th className="text-left">บ้านเลขที่</th><th className="text-left">ชื่อ-นามสกุล</th><th className="text-left">วันที่จดมาตร</th>
                      <th className="text-left">เลขมาตรเดือนนี้</th><th className="text-left">เลขมาตรเดือนก่อน</th><th className="text-left">จำนวนหน่วยที่ใช้</th>
                      <th className="text-left">ค่าน้ำประปา</th><th className="text-left">ค่ารักษาอุปกรณ์น้ำ</th><th className="text-left">ค่าส่วนกลาง</th>
                      <th className="text-left">ค่าขยะ</th><th className="text-left">ค่าเคเบิล</th><th className="text-left">รายรับอื่นๆ</th>
                      <th className="text-left">เพิ่ม/ลดหนี้</th><th className="text-left">ค่าเบี้ยประกัน</th><th className="text-left">ค่าต่อกลับมิเตอร์</th>
                      <th className="text-left">ค่าปรับชำระล่าช้า</th><th className="text-left">รวม(บาท)</th><th className="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.data?.length ? (
                      <tr><td colSpan={19} className="text-center py-3">ไม่มีข้อมูล</td></tr>
                    ) : (
                      data.data.map((item, index) => (
                        <tr key={index}>
                          <td><input type="checkbox" className="pointer" checked={item.selected || false} onChange={(e) => this.toggleItem(index, e.target.checked)} /></td>
                          <td>{item.address_number || "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td>{item.datetime_create ? format_date(item.datetime_create) : "-"}</td>
                          <td>{num(item.current_gauge_number)}</td>
                          <td>{num(item.last_gauge_number)}</td>
                          <td>{num(item.unit_used)}</td>
                          <td>{fmt(item.water_bill)}</td>
                          <td>{fmt(item.equipment_maintenance_fee)}</td>
                          <td>{fmt(item.common_expenses)}</td>
                          <td>{fmt(item.waste_cost)}</td>
                          <td>{fmt(item.cable_cost)}</td>
                          <td>{fmt(item.other_income)}</td>
                          <td>{fmt((item.add_debt || 0) - (item.reduce_debt || 0))}</td>
                          <td>{fmt(item.fire_cost)}</td>
                          <td>{fmt(item.meter_connect_cost)}</td>
                          <td>{fmt(item.total_cost_late)}</td>
                          <td>{fmt(item.total_amount)}</td>
                          <td className="text-center d-flex">
                            {!hasSelected ? (
                              <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer" onClick={() => this.setState({ id: item.record_water_id, modal_update: true })}>
                                <span className="icon text-danger">{"\uf2ed"}</span>
                              </label>
                            ) : <div className="hpx-24"></div>}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                ) : (
                <table className="table table-borderless table-striped text-nowrap">
                  <thead className="bg-dark-blue text-white">
                    <tr className="bg-primary">
                      <th><input type="checkbox" className="pointer" onChange={this.toggleAllItem} checked={data_item?.data?.length > 0 && data_item.data.every((item) => item.selected)} /></th>
                      <th className="text-left">บ้านเลขที่</th><th className="text-left">ชื่อ-นามสกุล</th><th className="text-left">วันที่จดมาตร</th>
                      <th className="text-left">เลขมาตรเดือนนี้</th><th className="text-left">เลขมาตรเดือนก่อน</th><th className="text-left">จำนวนหน่วยที่ใช้</th>
                      {writeoffItemColumns.map(col => <th className="text-left" key={col.key}>{col.label}</th>)}
                      <th className="text-left">รวม(บาท)</th><th className="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!data_item?.data?.length ? (
                      <tr><td colSpan={writeoffItemColumns.length + 8} className="text-center py-3">ไม่มีข้อมูล</td></tr>
                    ) : (
                      data_item.data.map((item, index) => (
                        <tr key={index}>
                          <td><input type="checkbox" className="pointer" checked={item.selected || false} onChange={(e) => this.toggleItemItem(index, e.target.checked)} /></td>
                          <td>{item.address_number || "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td>{item.meter_datetime_create ? format_date(item.meter_datetime_create) : "-"}</td>
                          <td>{num(item.current_gauge_number)}</td>
                          <td>{num(item.last_gauge_number)}</td>
                          <td>{num(item.unit_used)}</td>
                          {writeoffItemColumns.map(col => (
                            <td key={col.key}>{fmt(col.compute ? col.compute(item) : item[col.key])}</td>
                          ))}
                          <td>{fmt(item.total_selected_amount)}</td>
                          <td className="text-center d-flex">
                            {!hasSelectedItem ? (
                              <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mx-auto mb-0 pointer" onClick={() => this.setState({ id_item: item.writeoff_item_id, modal_update_item: true })}>
                                <span className="icon text-danger">{""}</span>
                              </label>
                            ) : <div className="hpx-24"></div>}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                )}
              </div>
              
              {activeData?.data?.length > 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3 mt-3">
                  <div className="d-flex align-items-center"><label className="mb-0">แสดง {activeData.end_index} รายการ จาก {activeData.count} รายการ</label></div>
                  <Pagination
                    count={activeData.page_number}
                    page={page}
                    color="primary"
                    showFirstButton
                    showLastButton
                    onChange={(e, value) => this.setState({ page: value }, list_mode === "new" ? this.GetAllItem : this.GetAll)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* MODAL UPDATE */}
        <Modal show={modal_update} onHide={() => this.setState({ modal_update: false })}>
          <Modal.Header><Modal.Title><b>ยืนยันการยกเลิกการตัดหนี้</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการยกเลิกการตัดหนี้ หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_update: false })}>ยกเลิก</button>
              <button className="btn btn-danger w-50 mx-1" onClick={() => this.cancelClearBill([this.state.id])}>ยืนยัน</button>
            </div>
          </Modal.Body>
        </Modal>

        {/* MODAL UPDATE (เลือกตัดเฉพาะรายการ) */}
        <Modal show={modal_update_item} onHide={() => this.setState({ modal_update_item: false })}>
          <Modal.Header><Modal.Title><b>ยืนยันการยกเลิกการตัดหนี้</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex mb-3"><label>ท่านแน่ใจว่าต้องการยกเลิกการตัดหนี้ หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label></div>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_update_item: false })}>ยกเลิก</button>
              <button className="btn btn-danger w-50 mx-1" onClick={() => this.cancelClearBillItem([this.state.id_item])}>ยืนยัน</button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}